var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnenrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5808 20L14.8923 19.3116L16.9923 17.2116L14.8923 15.1116L15.5808 14.4231L17.6808 16.5231L19.7808 14.4231L20.4692 15.1116L18.3942 17.2116L20.4692 19.3116L19.7808 20L17.6808 17.925L15.5808 20ZM11.4308 20C9.39999 20 7.62979 19.3369 6.12017 18.0106C4.61056 16.6843 3.73717 15.0141 3.5 13H4.51153C4.78333 14.7205 5.56698 16.1506 6.8625 17.2904C8.15802 18.4301 9.68078 19 11.4308 19C11.6141 19 11.7945 18.9958 11.9721 18.9875C12.1497 18.9792 12.3282 18.9583 12.5077 18.925V19.9308C12.3282 19.9603 12.1497 19.9792 11.9721 19.9875C11.7945 19.9958 11.6141 20 11.4308 20ZM4.43075 8.46155V4.3077H5.43075V6.69615C6.20383 5.84743 7.10992 5.18589 8.14902 4.71152C9.18812 4.23717 10.282 4 11.4308 4C13.6487 4 15.5365 4.77884 17.0942 6.33652C18.6519 7.89423 19.4308 9.78205 19.4308 12V12.2692H18.4308V12C18.4308 10.05 17.7516 8.39583 16.3933 7.0375C15.0349 5.67917 13.3808 5 11.4308 5C10.3962 5 9.42372 5.21859 8.51345 5.65578C7.6032 6.09296 6.8 6.69488 6.10385 7.46155H8.5846V8.46155H4.43075Z",
    fill: "#282828"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnenrollIcon);
export default __webpack_public_path__ + "static/media/unenroll-icon.826bc9de532edf341ae265f697e68d83.svg";
export { ForwardRef as ReactComponent };